<template>
  <div>
    <div
      :id="idName"
      :style="{
        pointerEvents: disabled ? 'none' : 'auto',
      }"
      :class="{ 'field-color-black': placeholder === value, disabled: $attrs.disable }"
      class="input-container field-border-box row hover-shadow no-wrap"
    >
      <!-- v-bind="$attrs" -->
      <q-input
        v-bind="$attrs"
        :model-value="computedVal"
        :mask="mask"
        :placeholder="placeholder"
        class="input-item-class gordita-300-11"
        :style="inputStyle"
        @blur="onBlur"
        @update:modelValue="computedVal = $event"
      />
      <div
        v-if="menuOptions.length > 1"
        class="line-divider"
      >
        <svg
          width="2"
          height="26"
          viewBox="0 0 2 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            stroke-linecap="round"
            x1="1"
            y1="4.37114e-08"
            x2="0.999999"
            y2="26"
            :stroke="COLORS['System/app_border']"
            stroke-width="1"
          />
        </svg>
      </div>
      <q-btn
        :disable="menuOptions.length === 1 || $attrs.disable"
        class="field-menu-dropdown-button focus-be-gone ripple-go-away"
        :class="{ 'field-menu-with-dropdown': menuOptions.length > 1 }"
        :style="menuStyle"
        :ripple="false"
        dense
      >
        <div
          class="menu-selected-option gordita-400-12"
          :class="{ 'input-with-menu--menu-open': menu }"
        >
          {{ selectedOption }}
          <svg
            v-show="menuOptions.length > 1"
            class="field-menu-dropdown-icon"
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.5 1.5L4.5 4.5L7.5 1.5"
              :stroke="strokeStyle"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>

        <q-menu
          v-model="menu"
          fit
          no-focus
          label="selectedOption"
          transition-show="jump-down"
          transition-hide="jump-up"
          content-class="incredi-selection-input"
          auto-close
        >
          <q-list dense>
            <q-item
              v-for="option in menuOptions"
              :key="option"
              class="incredi-menu-q-item gordita-400-12"
              :class="{ 'input-with-num-selected': option === selectedOption }"
              dense
              clickable
              @click="setSelectedOption(option)"
            >
              <q-item-section>{{ option }}</q-item-section>
            </q-item>
          </q-list>
        </q-menu>
      </q-btn>
    </div>
    <div
      v-if="inputHint"
      class="input-hint"
    >
      {{ inputHint }}
    </div>
  </div>
</template>
<script>
import COLORS from '@/design-system/colors.json';

export default {
  props: {
    placeholder: { type: [Number, String], default: '' },
    minValue: {
      type: Number,
      default: 0,
    },
    maxValue: {
      type: Number,
      default: Infinity,
    },
    value: {
      required: true,
    },
    defaultOption: {
      type: String,
    },
    filter: {
      type: String,
    },
    menuOptions: {
      type: Array,
    },
    mask: {
      type: String,
    },
    idName: {
      type: String,
      required: true,
    },
    inputWidth: {},
    menuMinWidth: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    inputHint: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      menu: false,
      selectedOption: this.defaultOption || this.menuOptions[0],
      COLORS,
    };
  },
  computed: {
    computedVal: {
      get() {
        return this._.appContext.config.globalProperties.$filters.inputWithMenuFilter(this.value, this.filter, this.selectedOption);
      },
      set(newVal) {
        this.$emit('inputChange', newVal, this.selectedOption);
      },
    },
    inputStyle() {
      if (this.inputWidth) return `width:${this.inputWidth}px`;
      return '';
    },
    menuStyle() {
      if (this.menuMinWidth) return `min-width:${this.menuMinWidth}px`;
      return '';
    },
    strokeStyle() {
      return this.COLORS['Text/text_low_old'];
    },
  },
  methods: {
    onBlur() {
      const result = this.value < this.minValue ? this.minValue : this.value;
      if (this.filter) {
        const aPrama = this._.appContext.config.globalProperties.$filters.inputWithMenuFilter(this.maxValue < result ? this.maxValue : result, this.filter, this.selectedOption);
        const bPrama = this.selectedOption;
        this.$emit('inputChange', aPrama, bPrama);
      } else this.$emit('inputChange', this.maxValue < result ? this.maxValue : result, this.selectedOption);
    },
    setSelectedOption(option) {
      this.selectedOption = option;
      this.$emit('inputChange', this._.appContext.config.globalProperties.$filters.inputWithMenuFilter(this.value, this.filter, option), this.selectedOption);
      this.$emit('optionSelected', { option, componentId: this.idName });
    },
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  opacity: 1 !important;
  justify-content: space-between;
  :deep(.q-btn.disabled) {
    cursor: initial !important;
    > *,
    svg,
    div,
    span {
      cursor: initial !important;
    }
  }
  :deep(.q-btn) {
    &::before {
      box-shadow: none !important;
    }
  }

  &.disabled {
    cursor: initial !important;
    background-color: $-system-app-background;
    border-color: $-system-app-border;

    :deep(.q-btn) {
      pointer-events: none;
    }

    &:hover {
      box-shadow: initial !important;
      border-color: $-system-app-border;
      border: 1px solid $-system-app-border !important;
    }

    input,
    :deep(input) {
      color: $-text-text-low-old !important;
    }

    :deep(.menu-selected-option) {
      cursor: initial !important;
      color: $-text-text-low-old !important;
    }
  }
  :deep(.q-btn.disabled) {
    opacity: 1 !important;
  }
}

.input-item-class {
  :deep(.q-field__control) {
    height: 100%;
  }
}
.field-color-black {
  input,
  :deep(input) {
    color: $-text--dark;
  }
}
.field-border-box {
  height: 36px;
  background: #ffffff;
  border: 1px solid #d8dfe2;
  box-sizing: border-box;
  border-radius: 2px;
  &:hover {
    border: 1px solid $-text--dark;
    box-shadow: unset;
  }
  &.field-border-box:focus-within {
    border: 2px solid $-system-app-primary !important;
    box-shadow: unset;
  }
  input,
  :deep(input) {
    width: 56px;
    /* max-width: 60%; */
    margin-left: 12px;
    margin-right: 0;
    border: 0;
    &:focus {
      outline: unset;
    }
  }

  select {
    border: 0;
    margin-left: auto;
    margin-right: 4px;
    font-size: 11px;
    font-weight: 500;
    line-height: 15px;
    color: $-text--dark;
  }
}
.menu-selected-option {
  &:not(.input-with-menu--menu-open) {
    color: $-text-text-low-old;
  }
  .input-with-menu--menu-open {
    color: $-text--dark;
  }
  &:hover {
    color: $-text--dark;
  }
  display: flex;
  align-items: center;
  gap: 12px;
}

.line-divider {
  height: 26px;
  width: 2px;
  align: center;
  margin: auto 0 auto auto;
}
.q-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 64px;
  padding: 0 8px;
  :hover {
    background-color: $-system-app-primary-bg !important;
  }
}
.input-hint {
  margin-top: 4px;
  font-size: 11px;
  line-height: 14.64px;
  color: $-text-text-low;
  text-transform: none;
  cursor: default;
}
:deep(.q-item--active) {
  font-family: Gordita-Bold;
}
:deep(.q-item__section) {
  display: flex;
  border-radius: 2px;
  align-items: center;
  /* display: flex !important;
  color: #04c094 !important;
  align-items: center !important;
  background-color: #ccfaea !important;
  border-radius: 2px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  font-size: 11px !important;
  font-family: 'Gordita-Regular' !important; */
}
:deep(.q-item) {
}
:deep(.q-field__control::before) {
  display: none;
}
:deep(.q-field__control::after) {
  display: none;
}
:deep(.q-focus-helper) {
  &::before {
    opacity: 1 !important;
  }
  &::after {
    opacity: 1 !important;
  }
  &:hover {
    opacity: 1 !important;
  }
}
</style>
